import type { ScopeOfWorkState } from "../../../shared/components/features/scope-of-work/context/scope-of-work.types";

const SECTOR_UID = "1e090328-9f51-4dda-bc5b-ba0da90bbda8";

function normalizeAreas(areas: any[] = []) {
  return areas.map((area) => {
    const { square, squareFootages, ...rest } = area;

    return {
      ...rest,
      quantity: Number(squareFootages?.[0]?.quantity ?? area.quantity ?? 0),
    };
  });
}

export function buildScopeOfWorkStatePatchPayload(
  state: ScopeOfWorkState,
  meta: {
    clientUid?: string | null;
    coverageAreaId?: number | null;
    companyId?: number | null;
    frequencyType?: string | null;
  } = {},
) {
  return {
    name: state?.service?.name ?? "Advanced Service",
    sectorsUid: SECTOR_UID,
    categoryUid: state?.category?.uid ?? "",
    typeOfPlaceUid: state?.places?.uid ?? "",
    typeOfServiceUid: state?.service?.uid ?? "",
    averagePeople: Number(state?.averagePeople) || 0,
    squareFootage: state?.squareft ?? "",
    typeOfService: {
      costBias: Number(state?.service?.costBias) || 1,
      baseRatePerHour: Number(state?.service?.baseRatePerHour) || 0,
    },
    frequencyType: state?.frequencyType ?? meta.frequencyType ?? "by_weekly",
    travelBufferTimeInGeneral: state?.travelBufferTimeInGeneral ?? 0,
    areas: normalizeAreas(state?.areas),
    otherAreas: normalizeAreas(state?.otherAreas),
    additionalObjects: state?.objects ?? [],
    specialRequests: state?.specialRequests ?? [],
    serviceNameOverride: state?.serviceNameOverride ?? "",
    costOverride: state?.costOverride ?? null,
    clientUid: meta.clientUid ?? null,
    coverageAreaId: meta.coverageAreaId ?? null,
    companyId: meta.companyId ?? null,
  };
}
